import { useState, useEffect } from 'react';

import className from 'classnames/bind';
import styles from './InducteeMembers.module.scss';
const cx = className.bind(styles);

type SignatueProps = {
  content: string;
};

export default function Signature({ content }: SignatueProps) {
  return <div className={cx("signature")} aria-hidden="true" dangerouslySetInnerHTML={{ __html: content }} />;
}
